import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';
import withWindow from '@surfline/quiver-react/dist/helpers/withWindow';
import windowPropType from '@surfline/quiver-react/dist/PropTypes/windowPropType';
import { PremiumRibbonIcon } from '@surfline/quiver-react';
import articlePropType from '../../propTypes/article';

const DEFAULT_PROMO_CONFIG = {
  dots: true,
  fade: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: false,
};

class PromoBox extends Component {
  getTitleContainerClasses = feedSuperheader =>
    classNames({
      'sl-promobox-slides__slide__title__container': true,
      'sl-promobox-slides__slide__title__container--superheader': feedSuperheader,
    });

  render() {
    const { doTrackFeed, promoBoxSlides, window } = this.props;
    const promoSettings = {
      ...DEFAULT_PROMO_CONFIG,
      infinite: !!window,
    };

    const end = window ? promoBoxSlides.length : 1;
    return (
      <div className="sl-promobox-slides">
        {promoBoxSlides.length ? (
          <Slider
            {...promoSettings}
            ref={el => {
              this.sliderRef = el;
            }}
          >
            {promoBoxSlides.slice(0, end).map((slide, index) => (
              <a
                key={slide.id}
                href={slide.permalink}
                target={slide.newWindow ? '_blank' : '_self'}
                className="sl-promobox-slides__slide"
                onClick={() =>
                  doTrackFeed('Clicked Home Feed Link', {
                    destinationUrl: slide.permalink,
                    mediaType: slide.media.type,
                    contentId: slide.id,
                    title: slide.content.title,
                    category: 'Promo Article',
                    contentType: 'Surf News',
                    tags: slide.tags,
                    locationCategory: 'homepage promobox',
                    promoPosition: index + 1,
                  })
                }
              >
                {slide.premium ? <PremiumRibbonIcon /> : null}
                <div className="sl-promobox-slides__slide__img__container">
                  <img
                    alt={slide.content.title}
                    src={slide.media.promobox1x}
                    srcSet={`${slide.media.promobox1x} 1x, ${slide.media.promobox2x} 2x`}
                  />
                </div>
                <div className={this.getTitleContainerClasses(slide.feedSuperheader)}>
                  {slide.feedSuperheader ? (
                    <div className="sl-promobox-slides__slide__superheader">
                      {slide.feedSuperheader}
                    </div>
                  ) : null}
                  <h1
                    className="sl-promobox-slides__slide__title"
                    dangerouslySetInnerHTML={{
                      __html: slide.content.displayTitle || slide.content.title,
                    }}
                  />
                </div>
              </a>
            ))}
          </Slider>
        ) : null}
      </div>
    );
  }
}

PromoBox.propTypes = {
  doTrackFeed: PropTypes.func.isRequired,
  promoBoxSlides: PropTypes.arrayOf(articlePropType).isRequired,
  window: windowPropType,
};

PromoBox.defaultProps = {
  window: null,
};

export default withWindow(PromoBox);
